// extracted by mini-css-extract-plugin
export default {"root":"IconCheckmarkCircle_root__O6lH+"};